import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import Avatar from '@mui/material/Avatar';
import { useLocation, useNavigate } from 'react-router-dom';
import InputEmoji from "react-input-emoji";
import SendIcon from "@mui/icons-material/Send";
import { Box, Button, FormControl, InputLabel, MenuItem, Modal, Select, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import toast from 'react-hot-toast';
import _ from 'lodash';

import ImageContainer from './ImageContainer';
import { autoGenerateReviews, getEmployees, replyInstaComment, deleteInstaReplyComment, replyYTComment } from 'app/store/fuse/reviewSlice';
import SideModal from '../Modals/SideModal';
import { apiClient } from 'app/configs/apiClient';
import ReviewDeleteModal from '../Modals/deleteModal';
import YoutubeVedeoModal from '../Modals/YoutubeVedeoModal';

// import ExportToPDFButton from '../ExportToPDFButton';

const YoutubeItem = ({ item, isNewTab = false }) => {

    //  const [youtube, setYoutubeItemItem] = useState(null);
    const [youtube, setYoutubeItem] = useState(null);

    const [currentReplyingCommentID, setCurrentReplyingCommentID] = useState('');
    const [currentReplyText, setCurrentReplyText] = useState('');
    const [showProgress, setShowProgress] = useState(false);
    const [isAIReplyTriggered, setIsAIReplyTriggered] = useState(false);
    const [AIReplyPayload, setAIReplyPayload] = useState('');
    const [AIReplyText, setAIReplyText] = useState('');
    const [isAIReplyTyping, setIsAIReplyTyping] = useState(false);
    const [generatedReplies, setGeneratedReplies] = useState([]);
    const [clickedProfile, setClickedProfile] = useState({});
    const [selectedCustom, setSelectedCustom] = useState("");
    const [customModalOpen, setCustomModalOpen] = React.useState(false);
    const [customData, setCustomData] = useState([]);
    const [allEmployee, setAllEmployee] = useState();
    const [selectedEmp, setSelectedEmp] = useState();
    const [customDataValues, setCustomDataValues] = useState({});
    const [openDeleteReplyModal, setOpenDeleteReplyModal] = useState(false);
    const [deletingReplyId, setDeletingReplyId] = useState(null);
    const [isOpenVedeoPlayer, setIsOpenVedeoPlayer] = useState(false)
    const [videoLink, setVideoLInk] = useState('')

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const { institutionGatewayDetailId } = useSelector(
        (state) => state.fuse.selectLocation
    );

    // useEffect to set youtube from item
    useEffect(() => {
        if (item) {
            const tempItem = {
                source: item?.source,
                pageName: item?.name,
                pageId: item?.pageId,
                pageAccessToken: item?.pageToken,
                description: item?.comment,
                createdTime: item?.create_time,
                postImage: item?.thumbnail,
                postId: item?.review_id,
                comments: item?.metaComments,
                likes: [], // add if needed
                postLink: item?.review_link,
                likesCount: item?.likes_count,
                commentsCount: item?.comments_count,
                dbId: item?.review_id,
                companyId: item?.company_id,
                gatewayDetailsId: item?.gateway_detail_id,
                platformId: item?.flat_form_id,
                updatedTime: item?.update_time,
                spioRatingType: item?.spio_rating_type,
                reviewType: item?.review_type,
                vedeoLink: item?.review_link
            };

            setYoutubeItem({ ...tempItem });
        }
    }, [item]);

    console.log("youtube", youtube);
    console.log("item", item);



    // For typing effect of currentReplyText
    useEffect(() => {
        if (AIReplyText) {
            setCurrentReplyText(''); // Reset text
            let index = 0;
            setIsAIReplyTyping(true); // set isAIReplyTyping to true so that the shorter, longer, etc buttons can be hidden until typing is completed
            const typingInterval = setInterval(() => {
                if (index < AIReplyText.length) {
                    setCurrentReplyText(AIReplyText.substring(0, index + 1)); // Use substring for precise slicing
                    index++;
                } else {
                    setIsAIReplyTyping(false); // set isAIReplyTyping to false so that the shorter, longer, etc buttons can be shown after typing is completed
                    clearInterval(typingInterval); // Stop when complete
                }
            }, 10); // 10ms per character

            return () => clearInterval(typingInterval); // Cleanup
        }
    }, [AIReplyText]);

    // FETCH ALL EMPLOYEES
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const data = await dispatch(getEmployees());
                setAllEmployee(data?.payload?.data);
            } catch (error) {
            }
        };

        fetchEmployees();
    }, []);

    const formatDateTime = (dateString) => {
        return moment(dateString).format("dddd, D MMMM YYYY , H:mm");
    };

    const onPressyoutube = () => {
        if (!isNewTab && youtube?.postId) {
            sessionStorage.setItem('latestYoutubePostId', youtube?.postId);
            navigate('/youtube-post');
            // navigate(`/instagram-post/${youtube?.postId}`);
        }
    };

    const onPressReplyButton = (currentComment) => {
        setCurrentReplyingCommentID(currentComment.id);
    };

    const onChangeReplyText = (text) => {
        setCurrentReplyText(text);
    };

    const onPressSendReplyIcon = async (currentComment) => {
        if (currentReplyText.length > 0) {
            setShowProgress(true);

            await dispatch(replyYTComment({
                review_id: item?.review_id,
                currentReplyingCommentID: currentReplyingCommentID,
                message: currentReplyText,
                gateway_details_id: institutionGatewayDetailId
            }));

            setShowProgress(false);
            // clear the reply text after sent
            setCurrentReplyText('');
        }
    };

    // FUNCTION FOR CREATING AUTOGENERATED REPLY BY TYPE LIKE SHORTER,LONGER...
    const handleAutogenerateReply = async (
        id,
        value,
        styleValue,
        GR_name,
        rating
    ) => {
        try {
            if (value) {
                const response = await dispatch(
                    autoGenerateReviews({ id, value, styleValue, GR_name, rating })
                );
                setAIReplyText(response.payload);
                setGeneratedReplies([...generatedReplies, response.payload]);
            }
        } catch (err) {
        }
    };

    const handleOpen = async (id) => {
        setSelectedCustom(id);
        setCustomModalOpen(true);

        try {
            const response = await apiClient().get(`/custom/value/${id}`);
            const customDatas = response.data.customValue;
            setCustomData(customDatas);
        } catch (error) {
            toast.error("Error fetching custom data");
        }
    };

    const handleClose = () => {
        setCustomModalOpen(false);
        setIsOpenVedeoPlayer(false)

    };

    const handleChangeText = (index, e) => {
        setCustomDataValues((prevValues) => ({
            ...prevValues,
            [customData[index].column_name]: e.target.value,
        }));
    };

    // FUNCTION FOR SAVING EMPLOYEES
    const handleSave = async () => {
        const formData = {
            selectedEmp,
            ...customDataValues,
        };

        try {
            const response = await apiClient().post(`/employee/save-employee?review_id=${selectedCustom}`, formData);
            toast.success("Added Successfully");
            setCustomModalOpen(false);
            setSelectedEmp("");
            setCustomDataValues({});
        } catch (error) {
            toast.error("Error for post data");
        }
    };

    const onPressDeleteReply = (replyId) => {
        setOpenDeleteReplyModal(true);
        setDeletingReplyId(replyId);
    };

    const tempComments = isNewTab ? youtube?.comments : youtube?.comments?.slice(0, 2);

    const location = useLocation();

    return (
        <div>
            {Array.isArray(generatedReplies) && generatedReplies?.length > 1 && (
                <SideModal
                    generatedReview={generatedReplies}
                    setGeneratedReview={setGeneratedReplies}
                    clickedProfile={clickedProfile}
                    setReplyText={setCurrentReplyText}
                    setOne={() => { }}
                />
            )}

            <div
                className={`flex flex-col pt-[24px] pr-[120px] pb-[24px] pl-[120px] gap-[32px] mb-[12px] ${isNewTab ? '' : 'cursor-pointer'}`}
                style={{
                    padding: "20px",
                    borderRadius: "16px",
                    backgroundColor: "#FAFBFD",
                    boxShadow: "0 1.98px 4.61px rgba(14, 31, 53, 0.25)",
                    flex: 1,
                }}
                onClick={onPressyoutube}
            >
                {/* CircularProgress */}
                {
                    showProgress && (
                        <div
                            className="fixed inset-0 flex items-center justify-center bg-lightgrey bg-opacity-50 z-50"
                            style={{ pointerEvents: 'auto' }}
                        >
                            <CircularProgress />
                        </div>
                    )
                }
                {/* Header */}
                <div className="flex flex-col md:flex-row  md:justify-between">
                    <div className="flex flex-row gap-12 w-full">
                        <div className="flex justify-center items-center align-middle">
                            <img
                                className="flex w-[51px] h-[51px] rounded-full"
                                src="https://img.icons8.com/?size=96&id=19318&format=png"
                                alt="Youtube Logo"
                            />
                        </div>
                        <div className="flex justify-between w-full">
                            <div className="flex-col">
                                <p className="font-500 text-lg">Youtube Post</p>
                                <p className="text-sm">{formatDateTime(youtube?.createdTime)}</p>
                            </div>
                            <div className="flex flex-row items-center">
                                <span className="font-500 text-lg">Page: {youtube?.pageName}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* FB Post */}
                <div className="flex flex-col pl-[60px] gap-12 items-left">
                    {
                        youtube?.description && (
                            <p className="text-lg">{youtube?.description}</p>
                        )
                    }
                    {
                        youtube?.postImage && (

                            <ImageContainer
                                key={youtube?.postId}
                                src={youtube?.postImage}
                                alt={youtube?.description?.substring(0, 50) || 'Youtube post'}
                                onClick={location.pathname === '/youtube-post' ? () => {
                                    setIsOpenVedeoPlayer(true)
                                    setVideoLInk(youtube?.vedeoLink)
                                } : undefined}
                            />
                        )
                    }
                    <div className="flex flex-row justify-between w-200">
                        <div className="flex flex-row gap-[5px]">
                            <ThumbUpIcon fontSize="small" style={{ color: '#3B5998' }} />
                            <p>{youtube?.likesCount ?? 0}</p>
                        </div>
                        <div className="flex flex-row gap-[5px]">
                            <p>{youtube?.commentsCount ?? 0}</p>
                            <p>{`Comment${(youtube?.commentsCount ?? 0) > 1 ? 's' : ''}`}</p>
                        </div>
                    </div>
                </div>
                {/* Comments */}
                {
                    tempComments?.map((comment) => {
                        let sortedReplies = [];
                        if (comment.replies?.length > 0) {
                            // Sort comment.replies in descending order by createdTime using Lodash
                            sortedReplies = _.orderBy(
                                comment.replies,
                                [
                                    (reply) => {
                                        const time = moment(reply.createdTime, moment.ISO_8601, true);
                                        // Return a large negative number for invalid dates to push them to the end
                                        return time.isValid() ? time.valueOf() : -Infinity;
                                    },
                                ],
                                ['desc']
                            );
                        }
                        const tempReplies = isNewTab ? sortedReplies : sortedReplies?.slice(0, 2);

                        if (!comment?.message) {
                            return <></>;
                        }
                        return (
                            <div className="flex flex-row  gap-[8px]">
                                {/* Avatar */}
                                <Avatar
                                    sx={{ width: 46, height: 46 }}
                                    src={comment?.from?.picture || undefined}
                                >
                                    {comment?.from?.picture ? null : comment?.from?.name?.charAt(0) || ''}
                                </Avatar>


                                <div
                                    style={{
                                        borderRadius: "16px",
                                    }}
                                    className="w-full"
                                >
                                    <div className="flex flex-col justify-end gap-10 ">
                                        <div className="flex flex-col">
                                            <div>
                                                {/* Comment Body */}


                                                <div
                                                    className="pt-[10px] px-[16px] pb-[16px] w-[85%]"
                                                    style={{
                                                        backgroundColor: "#F4F2F2",
                                                        borderRadius: "16px",
                                                    }}
                                                >
                                                    <p className="font-500 text-[14px] text-[#161614]">
                                                        {comment?.from?.name || ''}
                                                    </p>
                                                    <p
                                                        className="py-4 rounded-full relative z-10 text-[#3E3E3E] text-[16px] leading-[22px]"
                                                        style={{
                                                            borderRadius: "30px",
                                                        }}
                                                    >
                                                        {comment?.message}
                                                    </p>
                                                </div>
                                                <div className="flex justify-between w-[85%]">
                                                    <span className="ml-10 mt-3 mb-[8px]">
                                                        {formatDateTime(comment?.created_time)}
                                                    </span>
                                                </div>

                                                {/* Reply text box */}
                                                {
                                                    currentReplyingCommentID == comment?.id && (
                                                        <div className="flex items-end bg-white border !border-black rounded-xl text-red-500 p-10 mb-10 relative w-[85%]">
                                                            <div className="flex flex-col h-full w-[100%]">
                                                                <InputEmoji
                                                                    ref={inputRef}
                                                                    value={currentReplyText?.replace(/\n/g, "")}
                                                                    readOnly={false}
                                                                    onChange={(value) => {
                                                                        onChangeReplyText(value);
                                                                    }}
                                                                    cleanOnEnter
                                                                    // onEnter={() =>
                                                                    //   handleReply(data.review_id, replyText)
                                                                    // }
                                                                    placeholder="Type a reply"
                                                                    className="w-4/5 mr-2 react-emoji-picker--wrapper text-red-500 custom-emoji "
                                                                />

                                                                {/* shorter, longer, simpler, more casual, more professional, Regenerate AI reply buttons */}

                                                                {
                                                                    isAIReplyTriggered && currentReplyText && !isAIReplyTyping && (
                                                                        <div className="flex gap-10 pl-10 pb-5 mt-10 flex-wrap">
                                                                            {/* shorter AI reply button */}
                                                                            <div
                                                                                className={`border rounded-full px-[1rem] py-[0.2rem] !border-gray-400 auto-generate-option ${AIReplyPayload === "shorter"
                                                                                    ? "active-option"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    handleAutogenerateReply(
                                                                                        youtube?.dbId,
                                                                                        comment?.message,
                                                                                        "shorter",
                                                                                        comment?.from?.name,
                                                                                        5, // data?.rating_in_number // change when received from BE
                                                                                    );
                                                                                    setAIReplyPayload("shorter");
                                                                                    setClickedProfile({
                                                                                        id: youtube?.dbId,
                                                                                        coment: comment?.message,
                                                                                        reviewer_display_name:
                                                                                            comment?.from?.name,
                                                                                        rating: 5, // data?.rating_in_number // change when received from BE
                                                                                        style: "shorter",
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <FilterListIcon
                                                                                    className={`mr-[5px] ${AIReplyPayload === "shorter"
                                                                                        ? "text-gray-500"
                                                                                        : "text-gray-500"
                                                                                        }`}
                                                                                />
                                                                                <span>Shorter</span>
                                                                            </div>

                                                                            {/* longer AI reply button */}
                                                                            <div
                                                                                className={`border rounded-full px-[1rem] py-[0.2rem] !border-gray-400 auto-generate-option ${AIReplyPayload === "longer"
                                                                                    ? "active-option"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    setClickedProfile({
                                                                                        id: youtube?.dbId,
                                                                                        coment: comment?.message,
                                                                                        reviewer_display_name:
                                                                                            comment?.from?.name,
                                                                                        rating: 5, // data?.rating_in_number // change when received from BE
                                                                                        style: "longer",
                                                                                    });
                                                                                    handleAutogenerateReply(
                                                                                        youtube?.dbId,
                                                                                        comment?.message,
                                                                                        "longer",
                                                                                        comment?.from?.name,
                                                                                        5, // data?.rating_in_number // change when received from BE
                                                                                    );
                                                                                    setAIReplyPayload("longer");
                                                                                }}
                                                                            >
                                                                                <SortIcon
                                                                                    className={`mr-[5px] ${AIReplyPayload === "longer"
                                                                                        ? "text-gray-500"
                                                                                        : "text-gray-500"
                                                                                        }`}
                                                                                />
                                                                                <span>Longer</span>
                                                                            </div>

                                                                            {/* simpler AI reply button */}
                                                                            <div
                                                                                className={`border rounded-full px-[1rem] py-[0.2rem] !border-gray-400 auto-generate-option ${AIReplyPayload === "simpler"
                                                                                    ? "active-option"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    setClickedProfile({
                                                                                        id: youtube?.dbId,
                                                                                        coment: comment?.message,
                                                                                        reviewer_display_name:
                                                                                            comment?.from?.name,
                                                                                        rating: 5, // data?.rating_in_number // change when received from BE
                                                                                        style: "simpler",
                                                                                    });
                                                                                    handleAutogenerateReply(
                                                                                        youtube?.dbId,
                                                                                        comment?.message,
                                                                                        "simpler",
                                                                                        comment?.from?.name,
                                                                                        5, // data?.rating_in_number // change when received from BE
                                                                                    );
                                                                                    setAIReplyPayload("simpler");
                                                                                }}
                                                                            >
                                                                                <CheckCircleOutlineRoundedIcon
                                                                                    className={`mr-[5px] ${AIReplyPayload === "simpler"
                                                                                        ? "text-gray-500"
                                                                                        : "text-gray-500"
                                                                                        }`}
                                                                                />
                                                                                <span>Simpler</span>
                                                                            </div>

                                                                            {/* more casual AI reply button */}
                                                                            <div
                                                                                className={`border rounded-full px-[1rem] py-[0.2rem] !border-gray-400 auto-generate-option ${AIReplyPayload === "more casual"
                                                                                    ? "active-option"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    setClickedProfile({
                                                                                        id: youtube?.dbId,
                                                                                        coment: comment?.message,
                                                                                        reviewer_display_name:
                                                                                            comment?.from?.name,
                                                                                        rating: 5, // data?.rating_in_number // change when received from BE
                                                                                        style: "more casual",
                                                                                    });
                                                                                    handleAutogenerateReply(
                                                                                        youtube?.dbId,
                                                                                        comment?.message,
                                                                                        "more casual",
                                                                                        comment?.from?.name,
                                                                                        5, // data?.rating_in_number // change when received from BE
                                                                                    );
                                                                                    setAIReplyPayload("more casual");
                                                                                }}
                                                                            >
                                                                                <GroupOutlinedIcon
                                                                                    className={`mr-[5px] ${AIReplyPayload === "more casual"
                                                                                        ? "text-gray-500"
                                                                                        : "text-gray-500"
                                                                                        }`}
                                                                                />
                                                                                <span>More casual</span>
                                                                            </div>

                                                                            {/* more professional AI reply button */}
                                                                            <div
                                                                                className={`border rounded-full px-[1rem] py-[0.2rem] !border-gray-400 auto-generate-option ${AIReplyPayload === "more professional"
                                                                                    ? "active-option"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    setClickedProfile({
                                                                                        id: youtube?.dbId,
                                                                                        coment: comment?.message,
                                                                                        reviewer_display_name:
                                                                                            comment?.from?.name,
                                                                                        rating: 5, // data?.rating_in_number // change when received from BE
                                                                                        style: "more professional",
                                                                                    });
                                                                                    handleAutogenerateReply(
                                                                                        youtube?.dbId,
                                                                                        comment?.message,
                                                                                        "more professional",
                                                                                        comment?.from?.name,
                                                                                        5, // data?.rating_in_number // change when received from BE
                                                                                    );
                                                                                    setAIReplyPayload("more professional");
                                                                                }}
                                                                            >
                                                                                <WorkOutlineOutlinedIcon
                                                                                    className={`mr-[5px] ${AIReplyPayload === "more professional"
                                                                                        ? "text-gray-500"
                                                                                        : "text-gray-500"
                                                                                        }`}
                                                                                />
                                                                                <span>More Professional</span>
                                                                            </div>

                                                                            {/* regenerate AI reply button */}
                                                                            <div
                                                                                className="border rounded-full px-[1rem] py-[0.2rem] !border-gray-400 auto-generate-option"
                                                                                onClick={() => {
                                                                                    setClickedProfile({
                                                                                        id: youtube?.dbId,
                                                                                        coment: comment?.message,
                                                                                        reviewer_display_name:
                                                                                            comment?.from?.name,
                                                                                        rating: 5, // data?.rating_in_number // change when received from BE
                                                                                        style: "simpler",
                                                                                    });
                                                                                    handleAutogenerateReply(
                                                                                        youtube?.dbId,
                                                                                        comment?.message,
                                                                                        null,
                                                                                        comment?.from?.name,
                                                                                        5, // data?.rating_in_number // change when received from BE
                                                                                    );
                                                                                    setAIReplyPayload("simpler");
                                                                                }}
                                                                            >
                                                                                <CachedOutlinedIcon className="text-gray-500 mr-[5px]" />
                                                                                <span>Regenerate</span>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>

                                                            <div
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => {
                                                                    setIsAIReplyTriggered(true);
                                                                    setAIReplyPayload('simpler');
                                                                    handleAutogenerateReply(
                                                                        youtube?.dbId,
                                                                        comment?.message,
                                                                        'simpler',
                                                                        comment?.from?.name,
                                                                        5, // data?.rating_in_number // change when received from BE
                                                                    );
                                                                }}
                                                                className="text-red-500 mr-[30px] pb-[5px]"
                                                            >
                                                                <img src="assets/images/reviews/aiicon.svg" />
                                                            </div>

                                                            <SendIcon
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => onPressSendReplyIcon(comment)}
                                                                className="text-red-500 mr-[5px] pb-[5px]"
                                                            />
                                                        </div>
                                                    )
                                                }

                                                {/* Reply, Custom buttons */}

                                                {
                                                    (isNewTab && currentReplyingCommentID != comment?.id) && (
                                                        <div className=" flex flex-row-reverse gap-10 mb-12 w-[85%]">
                                                            {/* Reply button */}
                                                            <Button
                                                                className="hover:bg-red"
                                                                sx={{
                                                                    borderRadius: "8px",
                                                                    bgcolor: "#F30002",
                                                                    color: " #FFFFFF",
                                                                    fontSize: "16px",
                                                                    padding: "12px 20px 12px 20px",
                                                                    "&:hover": {
                                                                        bgcolor: "#FF4142",
                                                                        boxShadow:
                                                                            "0 1px 3px 1px rgba(0,0,0,0.15),0 1px 2px 0px rgba(0,0,0,0.3)",
                                                                    },
                                                                    "&:focused": {
                                                                        bgcolor: "#FF3739",
                                                                    },
                                                                }}
                                                                onClick={() => onPressReplyButton(comment)}
                                                            >
                                                                Reply
                                                            </Button>

                                                            {/* Custom button */}

                                                            <button
                                                                className="flex flex-row align-center justify-center text-center items-center"
                                                                style={{
                                                                    padding: "10px",
                                                                    border: "1px solid",
                                                                    borderRadius: "7px",
                                                                    color: "#161614",
                                                                    height: "38px",
                                                                    width: "100",
                                                                }}
                                                                onClick={() => handleOpen(youtube?.dbId)}
                                                            >
                                                                <span style={{}}>
                                                                    <img className="mr-10" src="assets/images/logo/Edit.svg" />
                                                                </span>
                                                                <span style={{ fontSize: "16px" }}>Custom</span>
                                                            </button>

                                                            {/* Custom button Modal */}

                                                            <Modal
                                                                open={customModalOpen}
                                                                onClose={handleClose}
                                                                aria-labelledby="child-modal-title"
                                                                aria-describedby="child-modal-description"
                                                                BackdropProps={{
                                                                    style: {
                                                                        backgroundColor: "rgba(0,0,0,0.1)",
                                                                    },
                                                                }}
                                                                className=""
                                                            >
                                                                <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-500 bg-white border-2 border-black p-20 md:p-40 rounded-[16px]">
                                                                    <h2 id="child-modal-title mb-10 text-500 ">
                                                                        Fill the custom fields
                                                                    </h2>
                                                                    <div
                                                                        className="flex fex-col justify-center items-center bg-opacity-100  w-full mt-20"
                                                                        style={{ maxHeight: "470px", overflowY: "auto" }}
                                                                    >
                                                                        <form>
                                                                            <span className="uppercase pb-5">SELECT EMPLOYEE</span>
                                                                            <FormControl className="w-full mb-16" fullWidth>
                                                                                <InputLabel id="demo-simple-select-label">
                                                                                    Select Employee
                                                                                </InputLabel>
                                                                                <Select
                                                                                    labelId="demo-simple-select-label"
                                                                                    id="outlined-basic"
                                                                                    value={selectedEmp}
                                                                                    onChange={(e) => setSelectedEmp(e.target.value)}
                                                                                >
                                                                                    {allEmployee?.filter((item, i) => item?.tbl_connect_employee_view == "active").map((data, index) => (
                                                                                        <MenuItem value={data?.tbl_connect_employee_id}>
                                                                                            {data?.tbl_connect_employee_name}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>

                                                                            <span></span>

                                                                            {customData?.map((item, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <span className="uppercase pb-5">
                                                                                            {item.column_name}
                                                                                        </span>
                                                                                        <TextField
                                                                                            id="outlined-basic"
                                                                                            variant="outlined"
                                                                                            className="w-full mb-16"
                                                                                            size="small"
                                                                                            value={customDataValues[item.column_name] || ""}
                                                                                            required
                                                                                            autoComplete="off"
                                                                                            onChange={(e) => handleChangeText(index, e)}
                                                                                            inputProps={{
                                                                                                pattern:
                                                                                                    item.column_name === "Phone number"
                                                                                                        ? "[0-9]*"
                                                                                                        : item.column_name === "Movie ID" || item.column_name === "Customer ID"
                                                                                                            ? "[A-Za-z0-9]*"
                                                                                                            : "[A-Za-z]*",
                                                                                            }}
                                                                                            onKeyDown={(e) => {
                                                                                                if (item.column_name === "Phone number") {
                                                                                                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                                                                                                        e.preventDefault();
                                                                                                    }
                                                                                                } else if (item.column_name === "Movie ID" || item.column_name === "Customer ID") {
                                                                                                    if (!/[A-Za-z0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                                                                                                        e.preventDefault();
                                                                                                    }
                                                                                                } else {
                                                                                                    if (!/[A-Za-z]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                                                                                                        e.preventDefault();
                                                                                                    }
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </form>
                                                                    </div>
                                                                    <div className="flex flex-row justify-end gap-10">
                                                                        <Button
                                                                            variant="outlined"
                                                                            className="rounded-6 h-[40px] bg-red text-white"
                                                                            size="small"
                                                                            onClick={handleSave}
                                                                        >
                                                                            Save
                                                                        </Button>
                                                                        <Button
                                                                            variant="outlined"
                                                                            className="rounded-6 h-[40px]"
                                                                            size="small"
                                                                            onClick={handleClose}
                                                                        >
                                                                            Cancel
                                                                        </Button>
                                                                    </div>
                                                                </Box>
                                                            </Modal>
                                                        </div>
                                                    )
                                                }

                                                {/* Replies */}
                                                {tempReplies?.map((reply, index) => {
                                                    return (
                                                        <div className="mb-[8px]">
                                                            <div
                                                                className="flex group justify-end mx-20"
                                                                key={index}
                                                            >
                                                                {/* delete button, to be shown only in the new tab */}
                                                                {
                                                                    isNewTab && (
                                                                        <button
                                                                            className="hidden group-hover:block mr-[8px]"
                                                                            onClick={() => {
                                                                                onPressDeleteReply(reply?.id);
                                                                            }}
                                                                        >
                                                                            <img
                                                                                style={{ background: "#8F8F8F" }}
                                                                                className="w-[3rem] border rounded-[16px] p-6"
                                                                                src="assets/images/logo/delete.svg"
                                                                                alt="Delete Icon"
                                                                            />

                                                                        </button>
                                                                    )
                                                                }
                                                                <div className="flex h-[auto] items-center">
                                                                    <span className="px-20 py-10 items-center relative z-0 rounded-[16px] bg-[#8F8F8F] flex justify-end text-white mr-[8px] text-[16px] lg:text-[18px] max-w-[80rem]">
                                                                        {reply?.message}
                                                                    </span>
                                                                    <Avatar
                                                                        sx={{ width: 46, height: 46 }}
                                                                        src={reply?.from?.picture || undefined}
                                                                    >
                                                                        {reply?.from?.picture ? null : reply?.from?.name?.charAt(0) || ''}
                                                                    </Avatar>
                                                                </div>
                                                            </div>
                                                            <div class="flex group justify-end">
                                                                <p
                                                                    className="px-20 mr-10 relative z-0 rounded-full w-1/8 md:w-1/8 flex items-end md:mr-[56px] text-[14px] text-[#3E3E3E]"
                                                                    style={{
                                                                        borderRadius: "30px",
                                                                    }}
                                                                >
                                                                    {formatDateTime(reply?.createdTime)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>

            <YoutubeVedeoModal
                isOpenVedeoPlayer={isOpenVedeoPlayer}
                setIsOpenVedeoPlayer={setIsOpenVedeoPlayer}
                handleClose={() => setIsOpenVedeoPlayer(false)}
                videoLink={videoLink}
            />

            <ReviewDeleteModal
                open={openDeleteReplyModal}
                handleClose={() => setOpenDeleteReplyModal(false)}
                deleteReviewId={{
                }}
                postId={youtube?.dbId}
                replyId={deletingReplyId}
                gatewayDetailsId={youtube?.gatewayDetailsId}
                platformId={youtube?.platformId}
                handleDeleteCallback={(flag) => setShowProgress(flag)}
            />
        </div>
    );
};

export default YoutubeItem;